
// 测试地址
// const api_url = 'https://api.gyukeji.com';

// 正式地址
// const api_url = 'http://119.3.182.127:30000';

// 地址
const api_url = process.env.VUE_APP_BASE_API;

export {
    api_url,
}
